/**
 * Indicate if the header should have fill color or if should be transparent on page load
 * Need to be rewritten to non-js
 */
function pageHeaderDetection() {
    // find the first section
    const firstSection = document.getElementById('section-number-1');
    // check if it has background color or background image
    const hasBgColor = firstSection.classList.contains('section--bg-color');
    const hasBgImg = firstSection.classList.contains('section--bg-img');
    const hasPageHeader = firstSection.classList.contains('s-page-header');
    const hasPageHeaderSimple = firstSection.classList.contains('s-page-header-simple');

    // keep the site header transparent
    if (hasBgColor || hasBgImg || hasPageHeader || hasPageHeaderSimple) {
        return;
    }

    // make site header white
    /* TODO: replace .js-no-page-header class with something js-header-white or js-header-fill-color */
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('js-no-page-header');
}

function openFirstTab(section) {
    const items = section.querySelectorAll('.c-list-expandable__item');
    const tabs = section.querySelectorAll('.s-tabs__tab');
    const firstItem = items[0];
    const firstTab = tabs[0];

    firstItem.classList.add('active');
    firstTab.classList.add('active');
}

function tabsResize(section) {
    if (window.innerWidth > 991) {
        const items = section.querySelectorAll('.c-list-expandable__item');
        let maxHeight = 0;

        items.forEach(function (item) {
            maxHeight = Math.max(maxHeight, item.offsetHeight);
        });

        section.querySelector('.c-list-expandable').style.height = maxHeight + 'px';
    } else {
        document.querySelectorAll('.s-tabs .c-list-expandable').forEach(function (el) {
            el.style.height = 'auto';
        });
    }
}

function loadSlider(slider) {
    let s = slider;
    let wrap = s.querySelector('.s-slider-final__wrap');
    let lastSlides = s.querySelectorAll('.s-slider-final__slide');
    lastSlides.forEach((el) => {
        el.classList.add('original-slide');
    });
    let clonedElements = Array.from(lastSlides, (el) => el.cloneNode(true));
    clonedElements.reverse();

    clonedElements.forEach((el) => {
        el.classList.remove('original-slide');
        el.classList.add('clone', 'initial-clone');
    });

    wrap.prepend(...clonedElements.reverse());

    let firstSlide = wrap.querySelectorAll('.initial-clone');
    firstSlide = firstSlide[firstSlide.length - 1].nextElementSibling;
    console.log(firstSlide);
    let offset = firstSlide.getBoundingClientRect().left + window.pageXOffset - wrap.getBoundingClientRect().left - window.pageXOffset;
    firstSlide.classList.add('active');

    wrap.style.marginLeft = -offset + 'px';
}

window.addEventListener('load', function () {
    pageHeaderDetection();
    document.body.classList.remove('preload');
    /* get all section with background color */
    const bgColorSections = document.querySelectorAll('.section--bg-color');

    /* do something with each found section */
    bgColorSections.forEach(function (section) {
        const sectionBgColor = window.getComputedStyle(section).getPropertyValue('background-color'),
            prevSection = section.previousElementSibling,
            nextSection = section.nextElementSibling;

        let prevSectionBgColor = null,
            nextSectionBgColor = null;

        if (prevSection !== null) {
            prevSectionBgColor = window.getComputedStyle(prevSection).getPropertyValue('background-color');
        }

        if (nextSection !== null) {
            nextSectionBgColor = window.getComputedStyle(nextSection).getPropertyValue('background-color');
        }

        /* if the current section has the same background color as prev section,
            reduce its top padding */
        if (null !== prevSection && sectionBgColor === prevSectionBgColor) {
            /* console.log('a section with bg-color before'); */
            section.classList.add('section--top-p-small');
        }

        /* if the current section has the same background color as next section,
            reduce its bottom padding */
        if (null !== nextSection && sectionBgColor === nextSectionBgColor) {
            /* console.log('a section with bg-color after'); */
            section.classList.add('section--bottom-p-small');
        }
    });

    document.querySelectorAll('.s-tabs').forEach(function (section) {
        openFirstTab(section);
        tabsResize(section);

        const imgElement = section.querySelectorAll('img.size-s-media__image');
        imgElement.forEach(function (image) {
            if (image.loading === 'lazy') {
                image.addEventListener('load', () => {
                    tabsResize(section);
                });
            }
        });
    });

    document.querySelectorAll('.s-slider-final').forEach(function (slider) {
        loadSlider(slider);
    });
});

require('./routes/other/animations');
require('./routes/other/datalayers');




// WEBPACK FOOTER //
// ./scripts/critical.js